import {ReactNode} from 'react';

import CheckmarkIcon from '~assets/images/icons/ui/checkmark.svg';
import {Text} from '~atoms/Text';

import {Box, Wrapper} from './styles';

type CheckboxProps = {
    value: boolean;
    onChange: (value: boolean) => void;
    disabled?: boolean;
    label?: ReactNode;
    cy: string;
};

export const Checkbox = ({value, onChange, disabled, label, cy}: CheckboxProps) => {
    return (
        <Wrapper
            onClick={() => !disabled && onChange(!value)}
            disabled={disabled}
            withLabel={Boolean(label)}
            data-cy={`${cy}-wrapper`}
        >
            <input
                type="checkbox"
                checked={value}
                data-cy={cy}
                onChange={() => {}}
            />
            <Box selected={value}>
                <CheckmarkIcon />
            </Box>
            {label && <Text>{label}</Text>}
        </Wrapper>
    );
};
